/**
 * @generated SignedSource<<1a567cfd1a2f6567b8a5e26574c4575c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TriggerRssCheckInput = {
  topicSlug: string;
};
export type TopicFormTriggerRssCheckMutation$variables = {
  input: TriggerRssCheckInput;
};
export type TopicFormTriggerRssCheckMutation$data = {
  readonly triggerRssCheck: {
    readonly feedsChecked: number;
    readonly ingestionTriggered: boolean;
    readonly message: string | null | undefined;
    readonly newContentFound: number;
    readonly success: boolean;
    readonly userErrors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type TopicFormTriggerRssCheckMutation = {
  response: TopicFormTriggerRssCheckMutation$data;
  variables: TopicFormTriggerRssCheckMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TriggerRssCheckPayload",
    "kind": "LinkedField",
    "name": "triggerRssCheck",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feedsChecked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newContentFound",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ingestionTriggered",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicFormTriggerRssCheckMutation",
    "selections": (v2/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopicFormTriggerRssCheckMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "31d4f4cbe31738eee4e22fdaf2ad92aa",
    "id": null,
    "metadata": {},
    "name": "TopicFormTriggerRssCheckMutation",
    "operationKind": "mutation",
    "text": "mutation TopicFormTriggerRssCheckMutation(\n  $input: TriggerRssCheckInput!\n) {\n  triggerRssCheck(input: $input) {\n    success\n    feedsChecked\n    newContentFound\n    ingestionTriggered\n    message\n    userErrors {\n      field\n      message\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "21b4f144e98d2712b452a81082735ce4";

export default node;
